import { render, staticRenderFns } from "./ButtonSection.vue?vue&type=template&id=10f9b484&scoped=true&"
import script from "./ButtonSection.vue?vue&type=script&lang=ts&"
export * from "./ButtonSection.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonSection.vue?vue&type=style&index=0&id=10f9b484&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f9b484",
  null
  
)

export default component.exports